const UsageTypeCheckIcon = ({ size = 56, className = "", isActive = false, ...props }) => {
  const fill = isActive ? "#68D7FF" : "#9EA6B2";
  const stroke = isActive ? "#68D7FF" : "white";
  const innerFill = isActive ? "#01BBFE" : "white";

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 56 56"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...props}
    >
      {/* Background shape */}
      <rect x="1" y="1" width="54" height="54" rx="27" fill={fill} fillOpacity="0.3" />
      <rect
        x="1"
        y="1"
        width="54"
        height="54"
        rx="27"
        stroke={`url(#gradient-${isActive ? "blue" : "white"})`}
        strokeWidth="2"
      />

      {/* Icon path (same for both) */}
      <path
        d="M32.609 17L23.391 17C19.387 17 17 19.387 17 23.391V32.609C17 36.613 19.387 39 23.391 39H32.609C36.613 39 39 36.613 39 32.609V23.391C39 19.387 36.613 17 32.609 17ZM25.767 31.19L23.292 33.665C23.127 33.83 22.918 33.907 22.709 33.907C22.5 33.907 22.28 33.83 22.126 33.665L21.301 32.84C20.971 32.521 20.971 31.993 21.301 31.674C21.62 31.355 22.137 31.355 22.467 31.674L22.709 31.916L24.601 30.024C24.92 29.705 25.437 29.705 25.767 30.024C26.086 30.343 26.086 30.871 25.767 31.19ZM25.767 23.49L23.292 25.965C23.127 26.13 22.918 26.207 22.709 26.207C22.5 26.207 22.28 26.13 22.126 25.965L21.301 25.14C20.971 24.821 20.971 24.293 21.301 23.974C21.62 23.655 22.137 23.655 22.467 23.974L22.709 24.216L24.601 22.324C24.92 22.005 25.437 22.005 25.767 22.324C26.086 22.643 26.086 23.171 25.767 23.49ZM34.116 33.082H28.341C27.89 33.082 27.516 32.708 27.516 32.257C27.516 31.806 27.89 31.432 28.341 31.432H34.116C34.578 31.432 34.941 31.806 34.941 32.257C34.941 32.708 34.578 33.082 34.116 33.082ZM34.116 25.382H28.341C27.89 25.382 27.516 25.008 27.516 24.557C27.516 24.106 27.89 23.732 28.341 23.732H34.116C34.578 23.732 34.941 24.106 34.941 24.557C34.941 25.008 34.578 25.382 34.116 25.382Z"
        fill={innerFill}
      />

      {/* Gradient definitions */}
      <defs>
        <linearGradient
          id={`gradient-${isActive ? "blue" : "white"}`}
          x1="3.95"
          y1="4.4"
          x2="50.76"
          y2="54.45"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor={stroke} />
          <stop offset="1" stopColor={stroke} stopOpacity="0" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export default UsageTypeCheckIcon;
